import React from "react";
import { Timer, Bell, Rocket, ArrowRight } from "lucide-react";
import { COLORS } from "../utils/constants";
import { translations, LanguageCode } from "../utils/translations";

interface ComingSoonProps {
  featureName?: string;
  description?: string;
  lang?: LanguageCode;
}

const ComingSoon: React.FC<ComingSoonProps> = ({
  featureName,
  description,
  lang = "en",
}) => {
  const t = translations[lang].comingSoon;
  const resolvedFeatureName = featureName || t.featureNameDefault;
  const resolvedDescription = description || t.description;

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "32px 20px",
      textAlign: "center",
      background: "#fff",
      borderRadius: "24px",
      boxShadow: "0 20px 50px rgba(0,0,0,0.04)",
      maxWidth: "800px",
      margin: "16px auto",
      border: "1px solid #f0f0f0",
      position: "relative",
      overflow: "hidden"
    }}>
      {/* Decorative background element */}
      <div style={{
        position: "absolute",
        top: "-50px",
        right: "-50px",
        width: "200px",
        height: "200px",
        borderRadius: "50%",
        background: `${COLORS.brandTeal}08`,
        zIndex: 0
      }} />

      <div style={{ 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center",
        width: "80px", 
        height: "80px", 
        borderRadius: "20px", 
        background: `${COLORS.brandPurple}10`,
        color: COLORS.brandPurple,
        marginBottom: "24px",
        zIndex: 1
      }}>
        <Rocket size={40} />
      </div>

      <div style={{ 
        display: "inline-flex", 
        alignItems: "center", 
        gap: "6px", 
        padding: "6px 14px", 
        borderRadius: "99px", 
        background: "#F3F4F6", 
        color: "#4B5563", 
        fontSize: "0.85rem", 
        fontWeight: 600,
        marginBottom: "16px",
        zIndex: 1
      }}>
        <Timer size={14} /> {t.badge}
      </div>

      <h2 style={{ 
        fontSize: "2.5rem", 
        fontWeight: 800, 
        color: COLORS.brandPurple, 
        marginBottom: "16px",
        letterSpacing: "-0.5px",
        zIndex: 1
      }}>
        {t.titleTemplate.replace("{feature}", resolvedFeatureName)}
      </h2>

      <p style={{ 
        fontSize: "1.1rem", 
        color: "#6B7280", 
        maxWidth: "500px", 
        margin: "0 auto 32px",
        lineHeight: "1.6",
        zIndex: 1
      }}>
        {resolvedDescription}
      </p>

      <div style={{ 
        display: "flex", 
        gap: "12px", 
        width: "100%", 
        maxWidth: "400px",
        zIndex: 1
      }}>
        <input 
          type="email" 
          placeholder={t.emailPlaceholder} 
          style={{
            flex: 1,
            padding: "14px 20px",
            borderRadius: "12px",
            border: "1px solid #E5E7EB",
            fontSize: "1rem",
            outline: "none",
            transition: "all 0.2s"
          }}
        />
        <button style={{
          padding: "14px 24px",
          borderRadius: "12px",
          background: COLORS.brandPurple,
          color: "#fff",
          border: "none",
          fontWeight: 700,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          transition: "all 0.2s"
        }}>
          <Bell size={18} /> {t.notifyBtn}
        </button>
      </div>

      <div style={{ 
        marginTop: "48px", 
        display: "flex", 
        alignItems: "center", 
        gap: "32px",
        zIndex: 1
      }}>
        <div style={{ textAlign: "left" }}>
          <div style={{ fontSize: "1.5rem", fontWeight: 800, color: COLORS.brandTeal }}>90%</div>
          <div style={{ fontSize: "0.75rem", color: "#9CA3AF", textTransform: "uppercase", fontWeight: 700 }}>{t.built}</div>
        </div>
        <div style={{ width: "1px", height: "30px", background: "#E5E7EB" }} />
        <div style={{ textAlign: "left" }}>
          <div style={{ fontSize: "1.5rem", fontWeight: 800, color: COLORS.brandTeal }}>2.4k</div>
          <div style={{ fontSize: "0.75rem", color: "#9CA3AF", textTransform: "uppercase", fontWeight: 700 }}>{t.inWaitlist}</div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
